import { createSelector } from '@ngrx/store';
import { selectUserGroupState } from 'src/app/core/store/user-groups/user-groups.selectors';
import IUserGroupsState from 'src/app/core/store/user-groups/user-groups.state';
import { adapter } from './users.reducers';
import IUserManagementState from './users.state';
import { selectCoreState } from '../core-feature-selector';
import { Dictionary } from '@ngrx/entity';
import { ITerminalUser } from 'src/app/features/settings/models/user.model';

export const selectUserManagement = createSelector(
  selectCoreState,
  (state) => state.users,
);

// get the entity selectors
const selectEntities = adapter.getSelectors().selectEntities;

/**
 * Selects the dictionary of the User Entities
 */
export const selectUserEntities = createSelector(
  selectUserManagement,
  selectEntities,
);

/**
 * Selects the users as an array
 */
export const selectUsers = createSelector(
  selectUserEntities,
  (userEntities: Dictionary<ITerminalUser>): ITerminalUser[] =>
    Object.values(userEntities ?? {}).filter(
      (user) => !!user,
    ) as ITerminalUser[],
);

/**
 * Select if Users or UserGroups are loading
 */
export const selectAreUsersLoading = createSelector(
  selectUserManagement,
  selectUserGroupState,
  (userManagement: IUserManagementState, userGroups: IUserGroupsState) =>
    userManagement.loadingUsers || !userGroups.groupsLoaded,
);

/**
 * Select if Users or UserGroups had a loading error
 */
export const selectUsersLoadError = createSelector(
  selectUserManagement,
  selectUserGroupState,
  (userManagement: IUserManagementState, userGroups: IUserGroupsState) =>
    userManagement.loadingUsersError || userGroups.loadingGroupsError,
);
